import { render, staticRenderFns } from "./Voltages.vue?vue&type=template&id=07ae27e4"
import script from "./Voltages.vue?vue&type=script&lang=js"
export * from "./Voltages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports